import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=5b45fa2c&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"
import style0 from "./Information.vue?vue&type=style&index=0&id=5b45fa2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45fa2c",
  null
  
)

export default component.exports